import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    state: {
        justifyContent: "center",
        flexGrow: 1
    }
});
export default stylesheet;
